import { Component } from 'react';

class AdditionalBox extends Component {
    constructor(props) {
        super();

        this.changeFirstPosition = this.changeFirstPosition.bind(this);
        this.changeSecondPosition = this.changeSecondPosition.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.state = {
            first_position: props.first_position ?? 6,
            second_position: props.second_position ?? 20,
            error: '',
        };
    }

    openModal(e) {
        e.stopPropagation();
    }

    changeFirstPosition(e) {
        const value = e.target.value;
        this.setState({
            first_position: value,
            error: '',
        });
    }

    changeSecondPosition(e) {
        const value = e.target.value;
        this.setState({
            second_position: value,
            error: '',
        });
    }

    onSubmit(e) {
        e.preventDefault();
        if (this.state.second_position <= this.state.first_position) {
            return this.setState({
                error: 'Check the numbers: the first one must be less than the second one.',
            });
        }

        this.props.changePositions(this.state.first_position, this.state.second_position);
    }

    render() {
        return (
            <>
                <div className="table-additional-view justify-content-between align-items-center">
                    <div>
                        <div className="striking-extra-container">
                            <form
                                onSubmit={this.onSubmit}
                                className="striking-extra-container-position"
                            >
                                <strong>
                                    {this.props.t(
                                        'opportunities.striking_distance.ranking_position',
                                    )}
                                    :{' '}
                                </strong>
                                <div className="striking-extra-container-fields">
                                    <input
                                        onChange={this.changeFirstPosition}
                                        value={this.state.first_position}
                                        className="striking-extra-input"
                                        type="number"
                                    />
                                    <span> {this.props.t('global.to')}</span>
                                    <input
                                        onChange={this.changeSecondPosition}
                                        value={this.state.second_position}
                                        className="striking-extra-input"
                                        type="number"
                                    />
                                </div>
                                <button className="striking-extra-btn">
                                    {' '}
                                    {this.props.t('opportunities.striking_distance.submit')}
                                </button>
                            </form>
                        </div>
                        {this.state.error && (
                            <div className="error-message">{this.state.error}</div>
                        )}
                    </div>
                </div>
            </>
        );
    }
}

export default AdditionalBox;
